import { help } from "../../constants/actionTypes";

const requestApiDoc = (data) => ({
  type: help?.REQUEST_API_DOC,
  payload: data,
});

const successApiDoc = (data) => ({
  type: help?.SUCCESS_API_DOC,
  payload: data,
});

const errorApiDoc = (data) => ({
  type: help?.ERROR_API_DOC,
  payload: data,
});

export { requestApiDoc, successApiDoc, errorApiDoc };
